import { render, staticRenderFns } from "./LandingBackground.vue?vue&type=template&id=456cf4d6&scoped=true&"
import script from "./LandingBackground.vue?vue&type=script&lang=js&"
export * from "./LandingBackground.vue?vue&type=script&lang=js&"
import style0 from "./LandingBackground.vue?vue&type=style&index=0&id=456cf4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cf4d6",
  null
  
)

export default component.exports